import { ACTION_POSITION, Banner } from "baseui/banner";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { LoadingView } from "../../../../components";
import { useGetObjectsChildren } from "../../../../hooks/useGetObjectsChildren";
import { useReportMutationState } from "../../../../hooks/useReportMutationState";
import { CreateObjectInstanceCommand, useCreateObjectMutation } from "../../../../services/objects";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { schema as schemaEnergyHeatmapBuilding } from "../../../ReportsAndStatistics/Energy/HeatmapBuilding/types";
import { AutomationObjectsFlexGridView } from "../../../components/Grid/AutomationObjectsFlexGridView";
import { PlantInsightApps } from "../../types";
import { modelId }  from "../../../Devices/BaseCounter/types"
import { useGetMatchQuery } from "../../../../services/objects";



const InsightsPanel = (props: any) => {
    const [css, theme] = themedUseStyletron()
    const { children, isLoading, isSuccess, refetch } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const childs = useMemo(() => children?.filter((v: any) => PlantInsightApps.includes(v.schema)), [children]);

    const hasEnergyHeatmap = children ? children.find(v => v.schema === schemaEnergyHeatmapBuilding) !== undefined : false;

    const { data: counters } = useGetMatchQuery({
        objectId: props.id,
        resourceGroupId: props.resourceGroupId,
        hops: '..3',
        relationship: 'Contains',
        modelId: modelId,
        queryParameters: 'CounterType=0'
    },{skip: !props.id || !props.resourceGroupId});
    

    const hasRelatedCounter = counters ? counters.length !== 0 : false;
    const hasCounterButNoApp = !hasEnergyHeatmap && hasRelatedCounter;

    const [create, createResult] = useCreateObjectMutation();
    useReportMutationState(createResult, () => { setTimeout(() => { refetch(); }, 2000) });

    const handleCreateObject = () => {

        const cmd: CreateObjectInstanceCommand = {
            name: `Energy`,
            resourceGroupId: props.resourceGroupId,
            description: `Energy`,
            schema: schemaEnergyHeatmapBuilding,
            parentId: props.id,
            properties: [
            ]
        }
        create(cmd);
    }

    return (<>
        <LoadingView isLoading={isLoading} isSucess={isSuccess}>

            {childs && <AutomationObjectsFlexGridView small={props.small} items={childs} flexGridColumnCount={props.flexGridColumnCount}></AutomationObjectsFlexGridView>}
            
            {hasCounterButNoApp && <Banner action={{
                label: 'Add',
                position: ACTION_POSITION.below,
                onClick: handleCreateObject,
            }}
                title={<FormattedMessage id="PlantInsightsPanel.addenergyheatmap" defaultMessage="Add Energy Heatmap" />}>
                <FormattedMessage id="PlantInsightsPanel.hasenergymeter" defaultMessage="This app has a related Energy meter. We recommend to add a Heatmap App to gain more insights." />
            </Banner>}
        </LoadingView>
    </>)
}

export default InsightsPanel